import { useEffect, useState } from 'react';
import { getQSObjectFromLocation, getValueOfQSObject } from '../../utils/qsUtils';
import ErrorPage from './ErrorPage';

const ErrorPageWithRouter = ({ location }) => {
  const [qs, setQs] = useState({});

  useEffect(() => {
    const qsObj = getQSObjectFromLocation(location);

    const msgFromQS = getValueOfQSObject(qsObj, 'msg') || '';
    const titleFromQS = getValueOfQSObject(qsObj, 'title') || '';
     

    setQs({msgFromQS,titleFromQS});
  }, [location]);

  return <ErrorPage msg={qs.msgFromQS} title={qs.titleFromQS}></ErrorPage>;
};

export default ErrorPageWithRouter;
